<template>
    <div v-if="visible">
        <v-dialog
            v-model="dialog"
            persistent
            max-width="700"
        >
            <v-card>
                <v-form ref="form" lazy-validation>
                    <v-card-title class="px-3">Edit User</v-card-title>
                    <v-divider></v-divider>
                    
                    <v-row class="px-4 py-4 pb-2">
                        <v-col md="12" sm="12" xs="12" class="pb-0">
                            <v-autocomplete
                                v-model="newMerchants"
                                label="Select a merchant"
                                :items="merchants"
                                item-value="uuid"
                                item-text="name"
                                dense
                                top
                                multiple
                                small-chips
                                :disabled="newUserRole <= 3"
                                :rules="[merchantRule]"
                            ></v-autocomplete>
                        </v-col>

                        <v-col md="12" sm="12" xs="12" class="pb-0">
                            <v-select
                                v-model="newUserRole"
                                label="Select a user role"
                                :items="userRoles"
                                item-value="id"
                                item-text="name"
                                dense
                                top
                                @change="newUserRoleHandler"
                            >
                                <v-tooltip slot="append" left>
                                    <template v-slot:activator="{ on }">
                                        <v-icon v-on="on" >mdi-information-outline</v-icon>
                                    </template>
                                    <div v-for="i in userRoles" :key="i.id">
                                        <span v-if="$store.state.user.user_role.id <= 3 && i.id == 4"><br>Merchant Level Roles<br></span>
                                        {{ i.name }}: {{ i.role_desc }}
                                    </div>
                                </v-tooltip>
                            </v-select>
                        </v-col>
                    </v-row>                    

                    <v-divider></v-divider>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="error" @click="$emit('close', false); response = null;">Close</v-btn>
                        <v-btn color="primary" @click="resetPassword(user)">Reset Password</v-btn>
                        <v-btn color="primary" @click="update(user)">Update</v-btn>
                        <v-btn v-if="canDisableUser" color="error" @click="disableDialog = true">Disable User</v-btn>
                    </v-card-actions>
                </v-form>
            </v-card>
        </v-dialog>

        <DisableUserDialog
            :visible="disableDialog"
            :user="user"
            @close="disableDialog = false"
            @confirm="disableUser"
        />

        <v-snackbar v-model="snackbar" color="primary">
            {{ result }}
            <v-icon color="white" @click="snackbar = false">mdi-close-circle</v-icon>
        </v-snackbar>
    </div>
</template>

<script>
import axios from 'axios';
import DisableUserDialog from './DisableUserDialogue.vue';

export default {
    components: {
        DisableUserDialog
    },
    props: {
        visible: Boolean,
        user: Object,
        merchants: Array,
        state: String
    },
    computed: {
        dialog() {
            return this.visible ? true : false;
        },
        canDisableUser() {
            // TP Admin only
            return this.$store.getters.role == 1;
        }
    },
    watch: {
        user() {
            console.log(this.user);
            if(this.user && this.user != undefined && this.user.merchantUuid != null) {
                this.newMerchants = (this.user.merchantUuid.replace(new RegExp('"', 'g'), '').replace('[', '').replace(']', '')).split(',');
            }
            else {
                this.newMerchants = [];
            }
            this.newUserRole = this.user ? this.user.user_role : null;
        }
    },
    beforeMount() {
        this.getUserRoles();
    },
    data() {
        return {
            newMerchants: [],
            newUserRole: null,
            userRoles: [],
            snackbar: false,
            result: null,
            disableDialog: false,
        }
    },
    methods: {
        update() {
           if(this.$refs.form.validate()) {
                axios({
                    method: 'post',
                    url: `update-user`,
                    data: { userId: this.user.id,
                            merchants: this.newMerchants,
                            userRole: this.newUserRole,
                            state: this.state },
                    config: { headers: { 'Content-Type': 'application/x-www-form-urlencoded' }}
                    })
                    .then(response => {
                        this.result = response.data.id ? 'Update successful' : null;
                        this.snackbar = response.data.id ? true : false;
                        this.$emit('update');
                    })
                    .catch(e => {
                        this.errors.push(e)
                })
           }
        },
        resetPassword() {
           axios({
                method: 'post',
                url: `reset-password`,
                data: { userId: this.user.id, merchant: this.user.merchantUuid },
                config: { headers: { 'Content-Type': 'application/x-www-form-urlencoded' }}
                })
                .then(response => {
                    this.result = response.data.id ? 'Password successful reset' : null;
                    this.snackbar = response.data.id ? true : false;
                })
                .catch(e => {
                    this.errors.push(e)
            })
       },
       getUserRoles() {
            axios({
                method: 'post',
                url: `get-user-roles`,
                data: { userRole: this.$store.state.user.user_role.id },
                config: { headers: { 'Content-Type': 'application/x-www-form-urlencoded' }}
                })
                .then(response => {
                    this.userRoles = response.data;
                })
                .catch(e => {
                    this.errors.push(e)
            })
        },
        newUserRoleHandler() {
            if(this.newUserRole <= 3) {
                this.newMerchants = null;
            }
        },
        merchantRule() {
            if(this.newMerchants.length == 0) {
                return 'Required';
            }
            else {
                return true;
            }
        },
        disableUser() {
            axios({
                method: 'post',
                url: `disable-user`,
                data: { userId: this.user.id },
                headers: { 'Content-Type': 'application/json'}
            })
            .then(response => {
                this.$emit('disable', {message: response.data.message});
                this.disableDialog = false;
            })
            .catch(error => {
                this.disableDialog = false;
                this.snackbar = true;
                this.result = error.response.data.message;
            });
        }
    }
}
</script>

<style>

</style>